import { useFeatureFlagValue } from '@/hooks/useFeatureFlag';
import { validatePositiveNumber } from '@/utils/numberValidation';

export const useGetSignUpBonusValue = (): number => {
  const value = useFeatureFlagValue('sign-up-bonus');
  return validatePositiveNumber(value);
};
